/** @jsx jsx */
import { Global } from '@emotion/core';
import 'bootstrap/dist/css/bootstrap.min.css';
import { graphql, useStaticQuery } from 'gatsby';
import { css, jsx, Layout as BaseLayout, Main } from 'theme-ui';
import Footer from '../Footer/';
import Header from '../Header/';
import SEO from '../SEO/SEO';
import { Main as mainStyles } from './Layout.styles.js';

export default function MainLayout({
  children,
  location,
  title,
  description,
  image,
  url,
  lang,
  meta,
  keywords,
  logo,
  header = {},
  footer = {},
  ...rest
}) {
  const {
    site: { siteMetadata },
  } = useStaticQuery(query);
  return (
    <BaseLayout lang={lang}>
      {/* Apply global styles, but with support for design tokens. */}
      <Global styles={theme => css(theme.styles.global)(theme)} />
      <SEO
        description={description}
        image={image}
        lang={lang}
        url={url}
        meta={meta}
        keywords={keywords}
        title={title}
      />
      <Header
        lang={lang}
        {...siteMetadata.header}
        {...header}
        location={location}
        logo={logo}
      />
      <Main sx={mainStyles} {...rest}>
        {children}
      </Main>
      <Footer
        lang={lang}
        location={location}
        {...siteMetadata.footer}
        {...footer}
        logo={logo}
      />
    </BaseLayout>
  );
}

export const query = graphql`
  {
    site {
      siteMetadata {
        siteTitle: title
        header {
          variant
        }
        footer {
          variant
        }
      }
    }
  }
`;
